module.exports = __webpack_public_path__ + "static/media/PlayMarket.6018d43d.svg";